export default {
  language: {
    'de': 'Deutsch',
    'en-US': 'Englisch',
  },
  view: {
    profile: {
      title: 'Account Profil',
      firstName: 'Vorname',
      lastName: 'Nachname',
      email: 'E-Mail',
      phone: 'Telefon',
      gender: 'Geschlecht',
      notifications: {
        header: 'Ich stimme folgenden E-Mail Benachrichtigungen zu',
        jobNote: 'Neuer Kommentar',
        application: 'Neue Bewerbung',
      },
      profilePanelTitle: 'Profilbild',
      uploadProfilePicture: 'Hochladen',
      deleteProfilePicture: 'Profilbild entfernen',
      resetPassword: 'Passwort ändern',
      cancel: 'Abbrechen',
      save: 'Speichern',
      passwordExplain:
        'Sie erhalten eine E-Mail mit einem Link zum Ändern Ihres Passworts.',
      deleteAccount: 'Konto löschen',
      deleteAccountConfirmation:
        'Sind Sie sicher, dass Sie Ihr Konto löschen möchten?',
      language: 'Sprache',
      reset: {
        title: 'Passwort ändern',
        fields: {
          password: {
            title: 'Passwort',
            placeholder: 'Passwort',
          },
          passwordConfirm: {
            title: 'Passwort (wiederholen)',
            placeholder: 'Passwort wiederholen',
          },
          errors: {
            passwordMismatch: 'Die Passwörter stimmen nicht überein.',
          },
        },
        button: {
          label: 'Passwort ändern',
        },
      },
    },
    accountSettings: {},
    login: {
      title: 'In Recruiter-Konto einloggen',
      registerNow: 'Sie haben kein Recruiter-Konto? <0>Jetzt registrieren</0>',
      forgotPassword: 'Passwort vergessen?',
      fields: {
        email: {
          title: 'E-Mail',
          placeholder: 'E-Mail',
        },
        password: {
          title: 'Passwort',
          placeholder: 'Passwort',
        },
      },
      buttons: {
        login: {
          label: 'Anmelden',
        },
        register: {
          label: 'Registrieren',
        },
      },
      info: {
        REGISTRATION_SUCCESS:
          'Sie haben die Registrierung erfolgreich abgeschlossen. Bitte melden Sie sich an.',
      },
    },
    legalPanel: {
      termsAndConditions: 'AGB',
      imprint: 'Impressum',
      privacyPolicy: 'Datenschutz',
      manageCookies: 'Cookies verwalten',
      faq: 'FAQ',
    },
    logout: {
      buttons: {
        logout: 'Abmelden',
        stay: 'Angemeldet bleiben',
      },
    },
    resetPassword: {
      title: 'Passwort zurücksetzen',
      registerNow: 'Sie haben kein Recruiter-Konto? <0>Jetzt registrieren</0>',
      forgotPassword: 'Passwort vergessen?',
      faq: 'FAQ',
      termsAndConditions: 'AGB',
      imprint: 'Impressum',
      privacyPolicy: 'Datenschutz',
      fields: {
        email: {
          title: 'E-Mail',
          placeholder: 'E-Mail',
        },
      },
      buttons: {
        reset: {
          label: 'Zurücksetzen',
        },
      },
      info: {
        START_PASSWORD_RESET_FLOW_SUCCESS:
          'Sie haben eine E-Mail zum Zurücksetzen Ihres Passworts erhalten.',
      },
    },
    register: {
      title:
        'Erstellen Sie jetzt ein Arbeitgeberprofil und starten Sie eine Recruiting-Kampagne.',
      alreadyRegistered: 'Haben Sie bereits ein Konto? <0>Anmelden</0>',
      disclaimer:
        'Ich habe die <0>Datenschutzerklärung</0> zur Kenntnis genommen und stimme den allgemeinen Geschäftsbedingungen zu. Dieses Einverständnis können Sie jederzeit widerrufen.',
      fields: {
        email: {
          title: 'E-Mail',
          placeholder: 'E-Mail',
        },
        password: {
          title: 'Passwort',
          placeholder: 'Passwort',
        },
        passwordConfirm: {
          title: 'Passwort (wiederholen)',
          placeholder: 'Passwort wiederholen',
        },
        errors: {
          passwordMismatch: 'Die Passwörter stimmen nicht überein.',
        },
        company: {
          title: 'Firmenname',
          placeholder: 'Firmenname',
          hint: 'Ihr rechtlich eingetragener Firmenname, z.B. funnellab GmbH',
        },
        firstName: {
          title: 'Vorname',
          placeholder: 'Vorname',
        },
        lastName: {
          title: 'Nachname',
          placeholder: 'Nachname',
        },
        phone: {
          title: 'Telefon',
          placeholder: 'Telefon',
        },
      },
      buttons: {
        register: {
          label: 'Registrieren',
        },
      },
      errors: {
        reCaptchaIncomplete:
          'Bitte bestätigen Sie, dass Sie kein Roboter sind.',
        registrationFailed:
          'Die Registrierung konnte nicht abgeschlossen werden. Bitte prüfen Sie, ob Ihre Organisation bereits registriert ist. Wenden Sie sich für eine Einladung an den Administrator Ihrer Organisation oder versuchen Sie es über die Login-Seite erneut, wenn Sie bereits einen Account haben.',
      },
    },
    verifyEmail: {
      sidePanel: {
        header: 'Wir müssen Ihre E-Mail verifizieren, bevor wir fortfahren.',
      },
      form: {
        header: 'Verifizierung',
        description:
          'Geben Sie den per E-Mail zugesandten Verifizierungscode ein',
        placeholder: 'Verifizierungscode eingeben',
        button: 'Verifizieren',
        resendCode: 'Code erneut senden',
        errorMessage:
          'Der Token ist falsch oder bereits abgelaufen.\nBitte fordern Sie einen neuen Token an und versuchen es erneut.',
      },
    },
    organizationInvite: {
      fields: {
        inviteeEmailAddress: {
          title: 'E-Mail',
          placeholder: 'E-Mail',
        },
      },
      buttons: {
        invite: {
          label: 'Einladen',
        },
      },
    },
    organizationInviteAccept: {
      buttons: {
        accept: {
          label: 'Einladung Akzeptieren',
        },
      },
      errors: {
        unknown: 'Unbekannter Fehler',
      },
    },
    error: {
      apology: 'Ups, da ist etwas schiefgegangen',
      retry: 'Erneut versuchen',
      details: 'Fehlerdetails:\n{{errorMessage}}\n\n{{stack}}',
      buttons: {
        logout: 'Abmelden',
        backToDashboard: 'Zurück zur Startseite',
      },
      serverUnavailable: 'Unser Server ist momentan nicht erreichbar.',
    },
    update: {
      buttonLabel: 'Jetzt aktualisieren',
      title: 'Neue Version verfügbar',
    },
    jobs: {
      title: 'Jobs',
      addJob: 'Neuer Job',
      columnId: 'ID',
      columnTitle: 'Titel',
      columnStatus: 'Status',
      columnOrganization: 'Organisation',
      columnDateUpdated: 'Letzte Änderung am',
      deleteJobConfirmation:
        'Sie sind dabei einen Job zu löschen. Sind Sie sicher?',
      edit: 'Job bearbeiten',
      delete: 'Job löschen',
      duplicate: 'Job kopieren',
      terminate: 'Kündigen',
      terminateInfoText:
        'Mit der Kündigung wird nur die aktuelle Kampagne zum {{endDate}} beendet. Ihr Konto bei funnellab bleibt bestehen und Sie können jederzeit neue Kampagnen starten.',
      terminationModal: {
        title: 'Sind Sie sicher, dass Sie kündigen wollen?',
        subTitle: 'Falls Sie bestätigen, endet Ihr Abonnement am {{endDate}}.',
        acceptLabel: 'Abo kündigen',
      },
      withdrawTermination: 'Kündigung zurückziehen',
      publish: 'Veröffentlichen',
    },
    organizationList: {
      title: 'Organisationen',
      addJob: 'Neuer Job',
      addOrganization: 'Neue Organisation',
      delete: {
        tooltip: 'Organisation löschen',
        confirmation:
          "Sie sind dabei eine Organisation {{name}} zu löschen.\nDiese Organisation könnte noch eingeladene und aktive Recruiter, so wie Jobs im Status '$t(common:jobStatus:offline)' oder '$t(common:jobStatus:draft)' haben.\nSind Sie sicher, dass Sie fortfahren möchten?",
        error:
          'Die Organisation {{name}} konnte nicht gelöscht werden. Prüfen Sie eventuelle blockierende Verknüpfungen und versuchen Sie es erneut.',
      },
    },
    chatbot: {
      popupHeader: 'Chatbot teilen',
      linkHeader: 'Link',
      instructionsHeader: 'Code einbetten',
      done: 'Fertig',
      linkCopiedToClipboard: 'Der Link wurde erfolgreich kopiert.',
      embedCodeCopiedToClipboard:
        'Der Einbettungscode wurde erfolgreich kopiert.',
      owner1_german_sie:
        'Herzlich willkommen! 👋 Der erste Schritt ist getan. Prüfen Sie jetzt, ob diese Stelle zu Ihnen passt.',
      owner1_german_du:
        'Herzlich willkommen! 👋 Der erste Schritt ist getan. Prüfe jetzt, ob diese Stelle zu dir passt.',
      owner1_english: 'Hi there, something went wrong in translation',
      user_companyDescription: 'Was erwartet mich?',
      user_tasks: 'Wie sehen meine Aufgaben aus?',
      user_qualifications: 'Welche Qualifikationen sollte ich mitbringen?',
      user_benefits: 'Welche Vorteile erwarten mich?',
      choose: 'Auswahl treffen',
      freeTextPlaceholder: 'Hier eingeben...',
      continue: 'Weiter',
      startPeriod: {
        now: 'Sofort',
        month_1: 'ca. in 1 Monat',
        month_2: 'ca. in 2 Monaten',
        month_3: 'ca. in 3 Monaten',
        month_3_plus: 'Später als in 3 Monaten',
      },
      contact: {
        translationError:
          'Hi there, something went wrong in translation. Please contact Support.',
        owner_wrapup_german_sie:
          'Super, das war es auch schon fast! Zum Schluss bitten wir Sie, Ihre Kontaktdaten (Name, E-Mail und Telefonnummer) anzugeben, damit Ihr potenzieller Arbeitgeber, **{{employer_brand}}**, Sie erreichen kann.',
        owner_wrapup_german_du:
          'Super, das war es auch schon fast! Zum Schluss bitten wir dich, deine Kontaktdaten (Name, E-Mail und Telefonnummer) anzugeben, damit Dein potenzieller Arbeitgeber, **{{employer_brand}}**, dich erreichen kann.',
        owner_wrapup_english: '$t(view.chatbot.contact.translationError)',
        owner_privacy_german_sie:
          '🔐 Wir gehen mit Ihren Daten vertrauensvoll um und nutzen Ihre Daten lediglich in Verbindung mit Bewerbungen. Hiermit bestätigen Sie, dass Sie die Datenschutzerklärung von funnellab verstanden haben, und stimmen dieser zu. Können wir fortfahren?',
        owner_privacy_german_du:
          '🔐 Wir gehen mit deinen Daten vertrauensvoll um und nutzen deine Daten lediglich in Verbindung mit Bewerbungen. Hiermit bestätigst Du, dass Du die Datenschutzerklärung von funnellab verstanden hast, und stimmst dieser zu. Können wir fortfahren?',
        owner_privacy_english: '$t(view.chatbot.contact.translationError)',
        name_german_sie: 'Wie lautet Ihr **Name (Vor- und Nachname)?**',
        name_german_du: 'Wie lautet Dein **Name (Vor- und Nachname)?**',
        name_english: '$t(view.chatbot.contact.translationError)',
        zipCode_german_sie:
          'Geben Sie bitte die **PLZ Ihres Wohnortes** an, damit wir die ungefähre Distanz zur Arbeitsstelle einschätzen können.',
        zipCode_german_du:
          'Gib bitte die **PLZ deines Wohnortes** an, damit wir die ungefähre Distanz zur Arbeitsstelle einschätzen können.',
        zipCode_english: '$t(view.chatbot.contact.translationError)',
        phone_german_sie:
          '☎ Für eventuelle Fragen zu Ihrer Bewerbung würden wir Sie gerne telefonisch kontaktieren. Wie lautet Ihre Telefonnummer (z. B. **+49 151126000012)?**',
        phone_german_du:
          '☎ Für eventuelle Fragen zu deiner Bewerbung würden wir dich gerne telefonisch kontaktieren. Wie lautet deine Telefonnummer (z. B. **+49 151126000012)?**',
        phone_english: '$t(view.chatbot.contact.translationError)',
        email_german_sie:
          '📧 Falls wir Sie telefonisch nicht erreichen können, kontaktieren wir Sie per E-Mail. Wie lautet Ihre **E-Mail-Adresse?**',
        email_german_du:
          '📧 Falls wir dich telefonisch nicht erreichen können, kontaktieren wir dich per E-Mail. Wie lautet deine **E-Mail-Adresse?**',
        email_english: '$t(view.chatbot.contact.translationError)',
      },
      privacy: {
        yes: 'Ja',
        privacy: 'Datenschutzerklärung',
        link: 'https://www.funnellab.com/de/datenschutz',
      },
      accept: {
        german_du:
          'Vielen Dank für Deine Bewerbung!\
        Dein potenzieller Arbeitgeber **{{employer_brand}}** wird sich zeitnah mit Dir in Verbindung setzen und den weiteren Verlauf der Bewerbung besprechen.\
        Der Erstkontakt findet in der Regel telefonisch statt.',
        german_sie:
          'Vielen Dank für Ihre Bewerbung!\
        Ihr potenzieller Arbeitgeber **{{employer_brand}}** wird sich zeitnah mit Ihnen in Verbindung setzen und den weiteren Verlauf der Bewerbung besprechen.\
        Der Erstkontakt findet in der Regel telefonisch statt.',
        english: '$t(view.chatbot.contact.translationError)',
      },
      reject: {
        german_du:
          'Vielen Dank für Deine Bewerbung! \
Wir haben Deine Angaben mit den Anforderungen des Arbeitgebers **{{employer_brand}}** abgeglichen und haben festgestellt, dass Du mindestens eine der Anforderungen für die Stelle nicht erfüllst. \
Wir werden Dich allerdings in den funnellab® Talent-Pool aufnehmen und kontaktieren Dich, sobald wir einen Job haben, der zu Dir passen könnte!',
        german_sie:
          'Vielen Dank für Ihre Bewerbung! \
Wir haben Ihre Angaben mit den Anforderungen des Arbeitgebers **{{employer_brand}}** abgeglichen und haben festgestellt, dass Sie mindestens eine der Anforderungen für die Stelle nicht erfüllen. \
Wir werden Sie allerdings in den funnellab® Talent-Pool aufnehmen und kontaktieren Sie, sobald wir einen Job haben, der zu Ihnen passen könnte!',
        english: '$t(view.chatbot.contact.translationError)',
      },
      toCompany: 'Zum Unternehmen',
      source: 'Quelle',
      appliedAT: 'Beworben am',
    },
    chatbotBuilder: {
      answerRating: {
        ideal: 'Ideal',
        possible: 'Möglich',
        reject: 'Ablehnen',
      },
      addAnswer: 'Antwort hinzufügen',
      publishChanges: 'Änderungen veröffentlichen',
      sidePanel: {
        mode: {
          title: 'Modus',
          live: 'Live',
          draft: 'Entwurf',
          preview: 'Vorschau',
        },
        content: 'Inhalt',
        questions: 'Fragen',
        companyDescription: 'Unternehmen',
        tasks: 'Arbeitsaufgaben',
        qualifications: 'Qualifikationen',
        benefits: 'Vorteile',
        addCustomQuestion: 'Frage hinzufügen',
        questionDeleteConfirmation:
          'Das Löschen einer Frage kann nicht rückgängig gemacht werden.',
      },
      attribute: {
        qualification: 'Qualifikation',
        qualification_description:
          'Welche Ausbildung oder welches Studium sollten Bewerber haben?',
        experience: 'Berufserfahrung',
        experience_description:
          'Welche Berufserfahrung sollten Bewerber mitbringen?',
        languageSkill: 'Sprachkenntnisse',
        languageSkill_description:
          'Es können max. 2 Fragen zu Sprachkenntnissen gestellt werden.\n\
        Eine gute Frage vom Typ "Sprachkenntnisse" sollte nach einer Sprache fragen und verschiedene Niveaus als Antwortoptionen bieten.',
        lastJob: 'Letzte Position',
        lastJob_description: 'Welche Job-Position hatten Bewerber zuletzt?',
        openText: 'Freitext',
        openText_description:
          'Frage, die Bewerber mit Freitext beantworten können.',
        startPeriod: 'Startzeitpunkt',
        startPeriod_description: 'Wann kann die Stelle begonnen werden?',
        custom: 'Benutzerdefiniert',
        custom_description:
          'Es kann im Chatbot max. 5 benutzerdefinierte Fragen geben.\n\
        Wir empfehlen den Fragetyp Einzelauswahl, wo möglich, damit die Antworten besser ausgewertet werden können.',
        freeTextShort: 'kurz (255 Zeichen)',
        freeTextLong: 'lang (1024 Zeichen)',
        deleteQuestion: 'Frage löschen',
        hideQuestion: 'Frage ausblenden',
        displayQuestion: 'Frage anzeigen',
      },
      questionType: {
        singleChoice: 'Einzelauswahl',
        multipleChoice: 'Mehrfachauswahl',
        freeTextShort: 'Freitext',
        rating: 'Bewertung',
      },
      configEditor: {
        description:
          'Der erste Schritt ist getan. Checken Sie jetzt, ob die Angaben korrekt sind.',
      },
      questionEditor: {
        question: 'Fragetext',
        enterQuestion: 'Fragetext hier eingeben',
        answerOptions: 'Antwortoptionen',
        questionTooltip: 'Diese Frage wird potentiellen Bewerbern gestellt.',
        selectAnswerType: 'Antworttyp auswählen',
      },
      errors: {
        publishFailed: 'Fehler beim Veröffentlichen der Änderungen',
        createQuestionFailed: 'Fehler beim Erstellen der Frage',
      },
    },
    support: {
      header: 'Support',
      mailLabel: 'Kontakt zum Support',
      callLabel: 'Rufen Sie uns an',
      faqHeader: 'FAQ',
      question1:
        'Wie erstelle ich eine Social Recruiting Kampagne mit Funnellab?',
      answer1:
        'Die Kampagnenerstellung ist einfach und strukturiert. Klicken Sie auf „Neuer Job“ und folgen Sie den einzelnen Schritten. Sie können eine bestehende Stellenanzeige hochladen, sodass alle relevanten Informationen automatisch übernommen werden. Alternativ hilft Ihnen unser intelligenter Eingabe-Assistent, alle wichtigen Daten Schritt für Schritt zu erfassen und optimal für die Kampagne aufzubereiten.\n\nWährend des Prozesses erhalten Sie zudem automatische Vorschläge basierend auf Ihrem Jobtitel sowie erklärende Infoboxen, die Ihnen helfen, die richtigen Angaben zu machen.',
      question2: 'Kann ich eine bestehende Kampagne bearbeiten oder pausieren?',
      answer2:
        'Ja, Sie haben volle Flexibilität! Solange sich die Kampagne im "Entwurf"-Status befindet, können Sie jederzeit Anpassungen über unseren intuitiven Kampagnen-Editor vornehmen. Nach der Veröffentlichung stehen Ihnen unsere Performance Recruiter zur Seite, um Änderungen gezielt und optimiert umzusetzen. So stellen wir sicher, dass Ihre Kampagne stets die besten Ergebnisse erzielt.',
      question3: 'Wie funktioniert die Vorqualifizierung der Bewerber?',
      answer3:
        'Die Bewerbervorqualifizierung erfolgt durch einen automatisierten Chatbot, der gezielte Fragen stellt, um die Eignung der Kandidaten zu prüfen. Dadurch werden nur qualifizierte Bewerbungen weitergeleitet, was die Effizienz des Auswahlprozesses erhöht.',
      question4: 'Wo kann ich meine eingehenden Bewerbungen einsehen?',
      answer4:
        'Derzeit werden alle Bewerbungen direkt an Ihr Bewerbermanagement-Tool (ATS) weitergeleitet. Eine integrierte Lösung zur direkten Verwaltung innerhalb von Funnellab ist bereits in Planung.',
      question5: 'Wie erhalte ich Benachrichtigungen über neue Bewerbungen?',
      answer5:
        'Benachrichtigungen über neue Bewerbungen werden per E-Mail versendet. Sie können die Empfänger direkt beim Erstellen der Kampagne festlegen oder später im jeweiligen Job anpassen.',
      question6: 'Kann ich mehrere Stellenanzeigen gleichzeitig verwalten?',
      answer6:
        'Ja, es gibt keine Begrenzung für die Anzahl der aktiven Jobs. Sie können mehrere Kampagnen gleichzeitig schalten und verwalten.',
      question7: 'Wie werden die passenden Kandidaten gefunden?',
      answer7:
        'Funnellab nutzt Funnel Recruiting, um zigtausende potenzielle Bewerber über Social Media gezielt anzusprechen. Ihre Stellenanzeige wird exakt an die passende Zielgruppe ausgespielt, und interessierte Kandidaten durchlaufen unseren smarten Recruiting-Chatbot, der sie effizient durch den Bewerbungsprozess führt.\n\nUnsere KI-gestützte Matching-Technologie analysiert die Antworten der Bewerber sowie ihren digitalen Fußabdruck, um sicherzustellen, dass die richtigen Talente angesprochen werden. So maximieren wir die Chancen, qualifizierte Bewerber für Ihre offene Position zu gewinnen.',
      question8: 'Wie wird das Recruiting-Budget berechnet?',
      answer8:
        'Das Recruiting-Budget wird individuell auf Basis der Jobkategorie festgelegt – je nachdem, ob Sie Nachwuchskräfte, Hilfskräfte, Fachkräfte oder Führungskräfte suchen. Zusätzlich haben Sie die Möglichkeit, mit der Boost-Funktion die Reichweite und Sichtbarkeit Ihrer Kampagne gezielt zu erhöhen.',
    },
    coaching: {
      header: 'Academy',
      bucket1: "Social Recruiting: So geht's!",
    },
  },
  menu: {
    organizations: 'Organisationen',
    employerBrands: 'Employer Brands',
    jobs: 'Jobs',
    contacts: 'Kontakte',
    close: 'Schließen',
    profile: 'Profil',
    logout: 'Abmelden',
    termsAndConditions: 'AGB',
    imprint: 'Impressum',
    privacyPolicy: 'Datenschutz',
    support: 'Support',
    coaching: '$t(view:coaching:header)',
    more: 'Mehr',
  },
  formValidation: {
    requirements: 'Anforderungen',
    invalidInput: 'Bitte prüfen Sie Ihre Eingabe.',
    empty: 'Die Eingabe darf nicht leer sein.',
    tooLong: 'Die Eingabe ist zu lang ({{length}}/{{maxLength}}).',
    tooLongArray:
      'Sie dürfen maximal {{maxLength}} Einträge hinzufügen (aktuell {{length}}).',
    tooShort: 'mindestens {{minLength}} Zeichen',
    mustContain: 'mindestens 1 {{example}}',
    mustNotContain: 'keine {{example}}',
    earliestPossibleDate:
      'Das frühestmögliche Datum ist der {{referenceDate}}.',
    latestPossibleDate: 'Das spätmöglichste Datum ist der {{referenceDate}}.',
    tooShortArray:
      'Bitte fügen Sie mindestens {{minLength}} Einträge hinzu (aktuell {{length}}).',
    outOfRangeMin: 'Die Eingabe muss mindestens {{min}} sein.',
    outOfRangeMax: 'Die Eingabe darf maximal {{max}} sein.',
    outOfRangeMinMax: 'Die Eingabe muss zwischen {{min}} und {{max}} liegen.',
    noDuplicates: 'Der Eintrag existiert bereits.',
    wrongFormat: 'Die Eingabe ist nicht im richtigen Format.',
    emailWrongFormat: 'Bitte prüfen Sie die Eingabe der E-Mail Adresse.',
    zipWrongFormat: 'Bitte prüfen Sie die Eingabe der Postleitzahl.',
    radiusRequired: 'Bitte geben Sie einen Radius an (min. 17km, max. 80km).',
    notEqual: 'Die Eingaben stimmen nicht überein.',
    duplicate: 'Der Wert existiert bereits.',
    whitespace: 'Leerzeichen',
    lowercase: 'Kleinbuchstaben (a-z)',
    uppercase: 'Großbuchstaben (A-Z)',
    specialChar: 'Sonderzeichen',
    number: 'Zahl (0-9)',
    email: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
    invalidPhoneNumber:
      'Bitte geben Sie eine gültige Telefonnummer für {{countryCode}} ein.',
    invalidVatNo:
      'Die Umsatzsteuer-Identifikationsnummer ist ungültig. Gültiges Format: {{valid_vat_no}}.',
    countryFilter: 'Land filtern',
  },
  table: {
    dateFormat: '$t(common:dateFormat)',
    yes: '$t(common:yes)',
    no: '$t(common:no)',
    search: 'Suche',
    totalResults: 'Gefundene Elemente: {{total}}',
    selected: 'Ausgewählt: {{selected}} von {{total}}',
    deselectAll: 'Alle abwählen',
    noEntry: 'Keine Einträge gefunden',
    organization: {
      externalId: 'ID',
      name: 'Name',
      employerBrands: 'Verknüpfte Arbeitgebermarken',
      jobs: 'Jobs',
    },
  },
  upload: {
    rejected: 'Abgelehnt',
    uploadProgress:
      '{{progressInPercent, number(maximumFractionDigits: 0)}}% hochgeladen',
    uploadedFileSize: ' {{fileSize}}',
    tryAgain: 'Erneut hochladen',
    uploadClick: 'Zum Hochladen klicken',
    uploadDragAndDrop: 'oder Drag & Drop',
    or: 'oder',
    acceptedFileFormats: '{{acceptedFileFormats}}',
    fileSizeRestriction: ' (max. {{maxFileSize}})',
    unknownError: 'Unbekannter Fehler',
    fileTooLarge: 'Datei ist zu groß',
    unknownFileType: 'Unbekannter Dateityp',
    tooManyFiles: 'Zu viele Dateien',
  },
  paginationPanel: {
    previous: 'Vorherige',
    next: 'Nächste',
    pageOf: 'Seite {{currentPage}} von {{numberOfPages}}',
  },
  jobWizard: {
    stepGeneral: {
      label: 'Wonach <highlight>suchen</highlight> Sie?',
    },
    stepEducation: {
      label:
        'Welche <highlight>An\u00ADfor\u00ADder\u00ADun\u00ADgen</highlight> gibt es für diese Rolle?',
    },
    stepSkills: {
      label: 'Welche <highlight>Fähigkeiten</highlight> erfordert die Stelle?',
      infoBox:
        "Tipp: Definiere die relevanten Fähigkeiten als 'Kann' oder 'Muss'. Dadurch kann die KI die Zielgruppe besser erfassen und den Algorithmus gezielt optimieren.",
    },
    stepTargetGroup: {
      label: 'Wer ist die <highlight>Zielgruppe</highlight>?',
      generatedHook: 'Ansprache der Zielgruppe',
      hookInfoText:
        'Der erste Satz der Anzeige entsteht automatisch aus den Angaben und dem Standort - und soll passende Bewerber direkt ansprechen.',
    },
    stepLocation: {
      label: 'Wo soll die <highlight>Kampagne</highlight> ausgespielt werden?',
    },
    stepSoftSkills: {
      label: 'Welche <highlight>Softskills</highlight> erfordert die Stelle?',
    },
    stepTasks: {
      label: 'Welche <highlight>Aufgaben</highlight> fallen an?',
    },
    stepEmployerBrand: {
      label:
        'Wählen Sie Ihre <highlight>Arbeit\u00ADgeber\u00ADmarke</highlight>!',
    },
    stepBenefits: {
      label: 'Welche <highlight>Benefits</highlight> bieten Sie?',
    },
    stepSalary: {
      label: 'Wie hoch ist das <highlight>Gehalt<highlight>?',
      infoBox:
        'Ein klar kommuniziertes Gehalt erhöht die Transparenz, stärkt das Vertrauen und sorgt dafür, dass sich nur wirklich interessierte und passende Personen bewerben - das spart Zeit und verbessert die Conversion.',
    },
    stepContacts: {
      label: 'Wer soll <highlight>Zugriff</highlight> erhalten?',
    },
    stepOrganization: {
      label: 'Wählen Sie Ihre <highlight>Organisation</highlight>!',
      alertText:
        'Die Organisation ist der Rechnungsträger. Hier hinterlegen Sie die Daten des Unternehmens, das die Kampagne bezahlt.\nIm nächsten Schritt (Employer Brand) legen Sie fest, wie das Unternehmen nach außen dargestellt wird.',
    },
    stepFiles: {
      label:
        'Haben Sie <highlight>job\u00ADspe\u00ADzi\u00ADfische Wer\u00ADbe\u00ADmit\u00ADtel</highlight>?',
      title: 'Bilder/Videos für Ihre Anzeige',
      infoText:
        'Laden Sie Bilder oder Videos hoch, die speziell für diese Kampagne verwendet werden sollen. Für größere Dateien (>20 MB) nutzen Sie bitte externe Links (z. B. WeTransfer, Google Drive).',
    },
    stepPriceCalculation: {
      label: 'Wie viele <highlight>Mitarbeiter</highlight> suchen Sie?',
      title: 'Social Recruiting Kampagne veröffentlichen',
      nextButton: 'Rechnungsdaten eintragen',
    },
    stepBillingAddress: {
      label: '<highlight>Social Recruiting Kampagne</highlight> jetzt buchen',
      highlight1: 'Erreichen Sie passive Arbeitssuchende über soziale Medien',
      highlight2: 'Vorqualifizierung von Kandidaten mit einem Bewerberbot',
      highlight3: 'AI-Optimierung auf der Grundlage der besten Bewerber',
      nextButton: 'Kampagne buchen',
      termsAndConditions: 'https://www.funnellab.com/de/agb',
    },
    stepPayment: {
      nextButton: 'Jetzt bezahlen',
      errors: {
        paymentSession: 'Unbekannter Fehler beim Laden des Payment Steps',
      },
    },
    educationInput: {
      title: 'Welche Ausbildung oder welches Studium wird benötigt?',
      placeholder: 'Ausbildung/Studium',
      infoText:
        'Geben Sie die relevanten Abschlüsse oder Qualifikationen an, die für diese Position erforderlich sind.',
    },
    experienceInput: {
      title: 'Welche Berufserfahrung ist erforderlich?',
      placeholder: 'Berufserfahrung',
      infoText:
        'Nennen Sie die gewünschten Erfahrungen, die für diese Position erforderlich sind.',
    },
    fullTimeInput: {
      title: 'Beschäftigungsart',
      fullTime: 'Vollzeit',
      partTime: 'Teilzeit',
      infoText:
        'Wählen Sie, ob die Stelle in Vollzeit, Teilzeit oder beidem angeboten wird.',
    },
    skillInput: {
      title: 'Fähigkeiten',
      addOption: 'Fähigkeit hinzufügen',
      addedSkills: 'Hinzugefügte Fähigkeiten ({{count}}/{{max}})',
      placeholder: 'Kenntnisse/Befugnisse',
      mustHave: 'Muss',
      niceToHave: 'Kann',
      infoText:
        'Listen Sie spezifische Kenntnisse oder Fähigkeiten auf, die für diese Position erforderlich sind.',
    },
    softSkillInput: {
      title: 'Softskills',
      placeholder: 'Softskills',
      infoText:
        'Listen Sie die Softskills auf, die für diese Position besonders wichtig sind, z. B. Teamfähigkeit.',
    },
    taskInput: {
      title: 'Aufgaben hinzufügen:',
      placeholder: 'Aufgabe',
      infoText:
        'Geben Sie mindestens 3 Aufgaben und maximal 6 Aufgaben an, die die Rolle präzise beschreiben.',
      errorMessage: 'Bitte fügen Sie mindestens 3 Aufgaben hinzu',
    },
    targetJobTitlesInput: {
      title: 'Kandidaten mit folgenden Jobtiteln:',
      placeholder: 'Jobtitel',
      infoText:
        'Optional. Wenn bestimmte Berufsbezeichnungen typisch für die Zielgruppe sind, hier 1-3 gezielt eintragen.',
    },
    targetCareerJumpersInput: {
      title: 'Quereinsteiger willkommen?',
      infoText:
        'Wählen Sie aus, ob auch Bewerber ohne direkte Erfahrung in diesem Bereich berücksichtigt werden sollen.',
    },
    targetExperienceEducationInput: {
      title: 'Kandidaten mit folgenden Erfahrungen und Abschlüssen:',
      placeholder: 'Erfahrungen und Abschlüsse',
      infoText:
        'Optional. Wenn bestimmte Erfahrungen oder Abschlüsse typisch für die Zielgruppe sind, hier 1-2 gezielt eintragen.',
    },
    workExperienceInput: {
      title: 'Wie viel Berufserfahrung ist mindestens notwendig?',
      NONE: 'Keine',
      LESS_THAN_ONE_YEAR: 'Unter 1 Jahr',
      ONE_TO_TWO_YEARS: '1-2 Jahre',
      THREE_TO_FIVE_YEARS: '3-5 Jahre',
      SIX_TO_TEN_YEARS: '6-10 Jahre',
      MORE_THAN_TEN_YEARS: 'Über 10 Jahre',
      infoText:
        'Wählen Sie die minimale Dauer an Erfahrung, die für diese Position erforderlich ist.',
    },
    jobTitleInput: {
      title: 'Jobtitel',
      placeholder: 'Jobtitel',
      infoText:
        'Wählen Sie einen Titel, der die Position klar beschreibt und für potentielle Mitarbeiter ansprechend wirkt.',
    },
    jobOrganizationInput: {
      title: 'Organisation',
      placeholder: 'Organisation',
      addOption: 'Organisation hinzufügen',
      errorUserRequired: 'Nutzer wurde nicht gefunden.',
      infoText:
        'Wählen Sie die Organisation aus, die die Kampagne veröffentlicht und auch als Rechnungsempfänger dient.',
    },
    jobBillingAddressInput: {
      title: 'Rechnungsadresse',
      infoText:
        'Geben Sie die Adresse ein, die auf der Rechnung ausgewiesen werden soll',
    },
    jobPaymentForm: {
      title: 'Zahlungsmethode',
      chooseMethod: 'Zahlungsmethode wählen',
      summary: 'Zusammenfassung',
      infoText: '',
      saveForFuturePayments: 'Speichern Sie dies für zukünftige Zahlungen',
      grandTotal: 'Gesamtbetrag (brutto)',
      header: {
        job: 'Job',
        quantity: 'Anzahl',
        unit_amount: 'Einzelpreis',
        total_amount: 'Gesamt',
      },
      month_one: '1 Monat',
      month_other: '{{count}} Monate',
      error: {
        unknownStripeError: 'Unbekannter Fehler bei der Zahlung',
        organizationNotSet: 'Die Organisation ist nicht gesetzt',
        countryNotSet: 'Das Land ist nicht gesetzt',
        organizationUpdate: 'Fehler beim Aktualisieren der Organisation',
        priceChanged:
          'Der Preis hat sich geändert. Bitte aktualisieren Sie die Seite.',
      },
    },
    jobOrganizationBillingEmailInput: {
      title: 'Rechnungs-E-Mail',
      placeholder: 'Rechnungs-E-Mail',
    },
    jobOrganizationStreetInput: {
      title: 'Straße, Hausnummer',
      placeholder: 'Straße, Hausnummer',
    },
    jobOrganizationZipInput: {
      title: 'PLZ',
      placeholder: 'PLZ',
    },
    jobOrganizationCityInput: {
      title: 'Stadt',
      placeholder: 'Stadt',
    },
    jobOrganizationCountryInput: {
      title: 'Land',
      placeholder: 'Land',
    },
    jobOrganizationVatNoInput: {
      title: 'USt-IdNr.',
      placeholder: 'USt-IdNr.',
    },
    jobInvoiceReferenceInput: {
      title: 'Rechnungsreferenz',
      placeholder: 'Rechnungsreferenz',
    },
    jobEmployerBrandInput: {
      title: 'Arbeitgebermarke',
      placeholder: 'Arbeitgebermarke',
      addOption: 'Arbeitgebermarke hinzufügen',
      errorOrganizationRequired: 'Bitte wählen Sie erst eine Organisation aus.',
      errorUserRequired: 'Nutzer wurde nicht gefunden.',
      infoText:
        'Unter welcher Arbeitgebermarke soll die Kampagne veröffentlicht werden? Diese kann vom Namen der Organisation abweichen.',
      updateAlert:
        'Sie sind gerade dabei, Ihre Arbeitgebermarke zu aktualisieren. Der neue Markenname wird in Zukunft anstelle des bisherigen verwendet werden.',
    },
    jobEmployerBrandBenefitsInput: {
      title: 'Die folgenden Benefits gelten für die gesamte Arbeitgebermarke',
      placeholder: 'Benefits',
      addOption: 'Benefits hinzufügen',
      infoText:
        'Geben Sie allgemeine Vorteile an, die für alle Positionen unter dieser Arbeitgebermarke gelten.',
    },
    jobBenefitsInput: {
      title: 'Die folgenden Benefits gelten individuell für die Stelle',
      placeholder: 'Benefits',
      infoText:
        'Listen Sie spezifische Vorteile auf, die ausschließlich für diese Stelle angeboten werden.',
    },
    jobEmployerBrandDescriptionInput: {
      title: 'Firmenbeschreibung',
      placeholder:
        'Beschreiben Sie in 4-8 Sätzen Ihre Arbeitgebermarke. Gerne können Sie den Text auch von der Webseite kopieren und hier einfügen.',
      infoText:
        'Beschreiben Sie Ihr Unternehmen in 4–8 Sätzen, um Bewerbern einen klaren Eindruck Ihrer Arbeitgebermarke zu vermitteln.',
    },
    jobEmployerBrandHomepageInput: {
      title: 'Webseite / Karriereseite',
      placeholder: 'Webseite / Karriereseite',
      infoText:
        'Geben Sie die URL Ihrer Webseite oder Karriereseite an, damit Interessenten mehr über Ihr Unternehmen erfahren können.',
    },
    jobEmployerBrandCIGuidelinesInput: {
      title: 'Corporate Identity Vorgaben',
      placeholder:
        'Bitte beschreiben Sie in 4-8 Sätzen Ihre Corporate Identity (CI), ggf. einschließlich Ihrer Markenwerte, Vision und Mission. Alternativ richten wir uns nach Ihrer Webseite.',
      infoText:
        'Ihre Vorgaben sichern eine konsistente Kampagne im Look Ihrer Marke. Alternativ können Sie uns auf Ihre Webseite verweisen.',
    },
    jobEmployerBrandCIDocumentsInput: {
      description: 'CI Dokumente, Logos, Bilder, etc. max 20MB, max 20 Dateien',
    },
    jobAddressingInput: {
      title: 'Anredeform der Kandidaten',
      placeholder: 'Anredeform',
      english: 'Englisch',
      german_sie: 'Deutsch (Sie)',
      german_du: 'Deutsch (Du)',
    },
    salaryTypeInput: {
      title: 'Gehalt',
      perMonth: 'pro Monat',
      perYear: 'pro Jahr',
      perHour: 'pro Stunde',
      infoText:
        'Geben Sie das Gehalt an, entweder als monatlichen oder jährlichen Betrag, um Transparenz zu schaffen.',
    },
    salaryRangeInput: {
      title: 'Spanne',
      min: 'von',
      max: 'bis',
      infoText:
        'Definieren Sie eine Gehaltsspanne, um Bewerbern Orientierung zu geben. Falls gewünscht, können Sie angeben, ob diese in der Kampagne sichtbar sein soll.',
    },
    showSalaryInput: {
      title:
        'Darf die Gehaltsspanne in der Recruiting Kampagne genannt werden?',
    },
    contactsInput: {
      title: 'Füge Recruiter hinzu, die Zugriff auf Bewerbungen erhalten:',
      placeholder: 'Kontakte',
      addOption: 'Kontakt hinzufügen',
      errorOrganizationRequired: 'Bitte wählen Sie erst eine Organisation aus.',
      errorLoadingRecruiters: 'Fehler beim Laden der Kontakte',
    },
    locationInput: {
      title: 'Standort oder Region:',
      placeholder: 'Adresse/Land',
      infoText:
        'Geben Sie den Standort der Stelle an, um gezielt Bewerber aus der passenden Region anzusprechen. Sie können auch Länder, Bundesländer oder spezifische Regionen auswählen.',
      locationTypeLabel: {
        street_address: 'Adresse',
        route: 'Straße',
        locality: 'Stadt',
        sublocality: 'Region',
        postal_code: 'Region',
        administrative_area_level_1: 'Region',
        administrative_area_level_2: 'Region',
        administrative_area_level_3: 'Stadt',
        country: 'Land',
      },
      radiusSuffix: 'km',
    },
    jobFilesInput: {
      description: 'Bilder, Videos, etc. max 20MB, max 20 Dateien',
    },
    jobLinksToExternalFilesInput: {
      title:
        'Links zu externen Drives (WeTransfer, Google Drive, Dropbox, OneDrive, etc.)',
      placeholder:
        'Falls Sie größere Dateien als 20 MB zur Verfügung stellen wollen, nutzen Sie bitte externe Drives oder WeTransfer und posten Sie hier den Link.',
    },
    unsavedChangesWarning:
      'Sie haben ungespeicherte Änderungen. Wollen Sie die Seite wirklich verlassen?',
    jobNumberOfPlannedHiresInput: {
      title: 'Anzahl der geplanten Neueinstellungen',
      infoText:
        'Geben Sie die Anzahl der Mitarbeiter an, die Sie mit dieser Kampagne einstellen möchten.',
    },
    jobRuntimeInput: {
      title: 'Laufzeit',
      infoText:
        'Wählen Sie die gewünschte Laufzeit der Kampagne aus. Die Laufzeit beeinflusst die Sichtbarkeit und Reichweite.',
      runtime_one: '1 Monat',
      runtime_other: '{{count}} Monate',
    },
    jobStartDateInput: {
      title: 'Start Datum',
      infoText: 'Wählen Sie aus, ab wann Sie die Kampagne schalten möchten.',
    },
    jobBoostInput: {
      title: 'Mit Boost mehr Bewerber gewinnen',
      infoText:
        'Aktivieren Sie den Boost, um die Kampagne an eine größere Zielgruppe auszuspielen und mehr Bewerber zu erreichen.',
    },
    jobAcceptTermsAndConditionsInput: {
      title: 'Ich akzeptiere die <0>Allgemeinen Geschäftsbedingungen</0>',
      infoText:
        'Bitte bestätigen Sie, dass Sie die Allgemeinen Geschäftsbedingungen gelesen und akzeptiert haben, um die Kampagne zu buchen.',
    },
    importAlert: {
      title: 'Stellenanzeige importieren & Kampagne starten!',
      body: 'Importieren Sie Stellenanzeigen einfach in funnellab – geben Sie nur den Titel und die Beschreibung ein, der Rest wird automatisch ausgefüllt.',
      button: { label: 'Stellenanzeige importieren' },
    },
    importModal: {
      title: 'Importieren Sie Ihre Stellenanzeige in Sekunden!',
      text: 'Importieren Sie Stellenanzeigen von Ihrer Website – geben Sie einfach den Titel und die Beschreibung ein, wir kümmern uns um den Rest.',
      infoText:
        'Diese Funktion basiert auf KI. Inhalte, die Sie nutzen oder erstellen, liegen in Ihrer Verantwortung. funnellab übernimmt keine Haftung. Verwenden Sie personenbezogene Daten und Geschäftsgeheimnisse nur, wenn Sie dazu berechtigt sind.',
      inputs: {
        title: { placeholder: 'Jobtitel', label: 'Jobtitel' },
        description: {
          placeholder: 'Stellenbeschreibung',
          label: 'Stellenbeschreibung',
        },
      },
      errorMessage:
        'Der Job konnte nicht importiert werden. Bitte versuchen Sie es erneut.',
      button: {
        label: 'Jetzt importieren',
      },
      loading: {
        title: 'Analyse Ihrer Stellenanzeige…',
        text: 'Wir verarbeiten Ihre Angaben – das dauert nur einen Moment.',
        button: { label: 'Import abbrechen' },
      },
    },
  },
  common: {
    combobox: {
      optionSelectError: 'Bitte wählen Sie eine Option aus der Liste.',
      addButtonLabel: 'Option hinzufügen',
      editButtonLabel: 'Option bearbeiten',
    },
    textInputWithOptions: {
      dropDownButtonLabel: 'Optionen anzeigen',
    },
    discard: 'Verwerfen',
    submitChanges: 'Änderungen veröffentlichen',
    dateFormat: 'DD.MM.YYYY',
    yes: 'Ja',
    no: 'Nein',
    delete: 'Löschen',
    button: {
      next: 'Weiter',
      previous: 'Zurück',
      save: 'Speichern',
      saveAsDraft: 'Als Entwurf speichern',
      close: 'Schließen',
      logout: 'Abmelden',
      cancel: 'Abbrechen',
      confirm: 'Bestätigen',
      finishWizard: 'Rechnungsdaten eingeben',
      add: 'Hinzufügen',
    },
    recommended: 'empfohlen',
    attention: 'Achtung',
    wizard: {
      step: 'Schritt {{current}}/{{total}}',
    },
    addRow: 'Zeile hinzufügen',
    errors: {
      INVALID_PAYLOAD: 'Ungültige Daten',
      INVALID_RESPONSE: 'Ungültige Antwort',
      INVALID_API_RESPONSE: 'Ungültige API Antwort',
      FAILED_VALIDATION: 'Validierung fehlgeschlagen',
      unknown: 'Unbekannter Fehler',
      NETWORK_ERROR: 'Netzwerkfehler',
      INVALID_CREDENTIALS: 'Benutzername oder Passwort falsch',
      UNAUTHORIZED: 'Keine Zugriffsrechte',
      TOKEN_EXPIRED: 'Session abgelaufen',
      NOT_FOUND: 'Element nicht gefunden',
      REGISTRATION_FAILED: 'Registrierung fehlgeschlagen',
      INVALID_STATUS_TRANSITION:
        'Der Status des Job konnte nicht geändert werden',
      DUPLICATE_INVITE: 'Diese Email-Adresse wurde bereits eingeladen',
      FORBIDDEN: 'Keine Berechtigung',
      UNPROCESSABLE_ENTITY: 'Interner Serverfehler',
      CONFLICT: 'Interner Serverfehler',
      errorWhileSaving: 'Fehler beim Speichern: {{errorMessage}}',
      INCOMPLETE_JOB_DATA: 'Jobdaten sind unvollständig',
      MISSING_CONFIG: 'Fehlende Konfiguration',
      PAYMENT: 'Fehler beim Bearbeiten der Zahlungsdaten',
      // ToDo: This should not happen -> We need a better errorMapping function!
      NOTHING_TO_DO: 'Ungültige Daten',
    },
    jobStatus: {
      draft: 'Entwurf',
      submitted: 'Eingereicht',
      online: 'Online',
      online_terminated: 'Online bis {{liveUntil}}',
      offline: 'Offline',
      reactivating: 'Reaktivierung',
      unknown: 'Unbekannt',
    },
    gender: {
      male: 'Männlich',
      female: 'Weiblich',
      other: 'Divers',
    },
    role: {
      Admin: 'Admin',
      Member: 'Mitglied',
    },
    empty: 'Hier gibt es derzeit nichts zu sehen.',
    notSet: 'Kein Anzeigewert vorhanden',
    suggestions: 'Vorschläge',
    validUntil: 'gültig bis',
    timeUnits: {
      short: {
        minute: '{{count}}m',
        hour: '{{count}}std',
        day: '{{count}}T',
        week: '{{count}}W',
        month: '{{count}}M',
        year: '{{count}}J',
      },
      long: {
        second_one: '1 Sekunde',
        second_other: '{{count}} Sekunden',
      },
    },
    user: {
      unknownUser: 'Unbekannter Benutzer',
    },
  },
  slider: {
    minimum: 'Minimum',
    maximum: 'Maximum',
  },
  errorMessages: {
    failedToAddOption: 'Fehler beim Hinzufügen',
    email: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
  },
  jobCreatedModal: {
    close: 'Schließen',
    success: 'Erfolg',
    successMessage: 'Sie haben einen neuen Job erstellt!',
  },
  errorModal: {
    title: 'Es ist ein Fehler aufgetreten',
    description:
      'Bitte versuchen Sie es erneut oder wenden Sie sich mit den Fehlerdetails an den Support.',
    details: 'Fehlerdetails',
    close: 'Schließen',
  },
  recruiterView: {
    tabHeaderAccepted: 'Mitglieder',
    tabHeaderInvited: 'Eingeladene Mitglieder',
    inputPlaceholder: 'E-Mail oder Name',
    buttonLabel: 'Einladen',
    tooltipAdminRole:
      'Admin-Benutzer: Voller Zugriff auf alle Jobs der Organisation.',
    tooltipMemberRole:
      'Mitglied-Benutzer: Zugriff nur auf eigene Jobs und Jobs bei denen er als Recruiter eingetragen ist.',
    resendInvite: 'Einladung erneut senden',
  },
  jobDetails: {
    overview: 'Übersicht',
    general: 'Allgemein',
    applicants: 'Bewerber',
    funnel: 'Funnel',
    recruiter: 'Recruiter',
    recruiter_other: '{{count}} Recruiter',
    contact: 'Meeting vereinbaren',
    organization: 'Organisation',
    employerBrand: 'Arbeitgeber\u00ADmarke',
    invoiceReference: 'Rechnungs\u00ADreferenz',
    campaignBudget: 'Kampagnen\u00ADbudget',
    campaignId: 'Kampagnen ID',
    perMonth: ' / Monat',
    nextRenewal: 'Nächste Verlängerung',
    history: 'Historie',
    tabNotes: 'Notizen',
    notesPlaceholder:
      'Machen Sie eine Notiz für Ihre Kollegen, den Social-Recruiting-Experten und sich selbst.',
    tabFiles: 'Dateien',
    errorUpdatingJob: 'Fehler beim Speichern: {{errorMessage}}',
    ad: 'Anzeige',
    geotargeting: 'Geo-Targeting',
    creatives: 'Creatives',
    chatbot: 'Chatbot',
    share: 'Teilen',
    unknownCategory: 'Unkategorisiert',
    categoryTitle: '{{category}} ({{count}})',
    recruiterPopup: {
      modalTitel: 'Recruiter einladen',
    },
    migrationHint: {
      text: 'Achtung, dieser Job wurde automatisch migriert. Möglicherweise fehlen Angaben!',
      creatives: 'Creatives',
      adText: 'Anzeigetext',
      chatbot: 'Chatbot',
      trelloLink: 'Bewerberlink',
      metaCampaign: 'meta Kampagne',
      button: 'Job ist vollständig',
    },
    ats: {
      menu: {
        manageLabels: 'Labels verwalten',
        showCCandidates: 'C Kandidaten anzeigen',
        hideCCandidates: 'C Kandidaten ausblenden',
      },
      defaultPhases: {
        applied: 'Beworben',
        qualificationCall: 'Qualifizierungscall',
        videoInterview: 'Video-Interview',
        interview: 'Interview',
        trialWork: 'Probearbeiten',
        potentialAnalysis: 'Potenzialanalyse',
        offer: 'Angebot',
        rejected: 'Abgelehnt',
        hired: 'Eingestellt',
      },
      defaultLabels: {
        high: 'hoch',
        medium: 'mittel',
        low: 'niedrig',
      },
      labels: {
        inputPlaceholder: 'Name eingeben',
        addLabel: 'Label hinzufügen',
        deleteConfirmMessage:
          'Sie sind dabei ein Label zu löschen.\nDas Label wird ebenfalls aus allen verknüpften Bewerbern entfernt. Möchten Sie fortfahren?',
      },
      phases: {
        addPhase: 'Pipeline hinzufügen',
        placeholder: 'Name eingeben',
        changeColor: 'Farbe anpassen',
        addApplicant: 'BewerberIn hinzufügen',
        defaultPhaseTooltip:
          'Diese Bewerberphase ist fest im System hinterlegt und stellt einen essenziellen Bestandteil des Bewerbungsprozesses dar. Sie kann daher nicht bearbeitet oder gelöscht werden.',
      },
      applicant: {
        detail: {
          inPhase: 'In Liste',
          label: 'Label',
          rejectionMailSent: 'Absage-Email versendet am {{date}}',
          sendRejectionEmail: 'Absage-Email senden',
          sendRejectionEmailConfirm: {
            title: 'Absage-Email versenden?',
            body: 'Nach Bestätigung wird die Absage per Email an {{applicantName}} ({{applicantEmail}}) gesendet. Anschließend erfolgt die automatische Verschiebung in die Pipeline-Phase „$t(jobDetails:ats:defaultPhases:rejected)“',
            confirm: 'Absage senden',
            error:
              'Es ist ein Fehler beim Senden der Absage-Email aufgetreten. Bitte versuchen Sie es später erneut.',
          },
          userData: {
            header: 'Benutzerdaten',
            telephone: 'Telefon',
            email: 'Email',
            zip: 'PLZ',
            forceShow: 'Immer anzeigen',
            bestReachability: {
              label: 'Beste Erreichbarkeit',
              morning: 'Morgens',
              noon: 'Mittags',
              afternoon: 'Nachmittags',
              night: 'Abends',
            },
          },
          qualifications: {
            header: 'Qualifikationen',
            qualityLabel: 'Bewerber\u00ADqualität',
          },
          attachments: {
            header: 'Anhänge',
            showMore: 'Mehr anzeigen',
            showLess: 'Weniger anzeigen',
            add: 'Dokument hinzufügen',
          },
          activitiesAndComments: {
            header: 'Aktivitäten und Kommentare',
            phaseChanged:
              '{{name}} hat den Bewerber von {{oldValue}} nach {{newValue}} verschoben.',
            bestReachabilityChanged:
              '{{name}} hat die beste Erreichbarkeit von {{oldValue}} auf {{newValue}} geändert.',
            bestReachabilitySet:
              '{{name}} hat die beste Erreichbarkeit auf {{newValue}} gesetzt.',
            bestReachabilityRemoved:
              '{{name}} hat die beste Erreichbarkeit entfernt.',
            nameChanged:
              '{{name}} hat den Namen von {{oldValue}} auf {{newValue}} geändert.',
            nameSet: '{{name}} hat den Namen auf {{newValue}} gesetzt.',
            nameRemoved: '{{name}} hat den Namen entfernt.',
            emailChanged:
              '{{name}} hat die Email von {{oldValue}} auf {{newValue}} geändert.',
            emailSet: '{{name}} hat die Email auf {{newValue}} gesetzt.',
            emailRemoved: '{{name}} hat die Email entfernt.',
            zipChanged:
              '{{name}} hat die PLZ von {{oldValue}} auf {{newValue}} geändert.',
            zipSet: '{{name}} hat die PLZ auf {{newValue}} gesetzt.',
            zipRemoved: '{{name}} hat die PLZ entfernt.',
            phoneChanged:
              '{{name}} hat die Telefonnummer von {{oldValue}} auf {{newValue}} geändert.',
            phoneSet:
              '{{name}} hat die Telefonnummer auf {{newValue}} gesetzt.',
            phoneRemoved: '{{name}} hat die Telefonnummer entfernt.',
            attachmentsSet: '{{name}} hat die Datei {{newValue}} hochgeladen.',
            attachmentsRemoved: '{{name}} hat die Datei {{oldValue}} gelöscht.',
            avatarSet: '{{name}} hat einen Avatar hochgeladen.',
            avatarRemoved: '{{name}} hat den Avatar entfernt.',
            labelsSet: '{{name}} hat das Label {{newValue}} hinzugefügt.',
            labelsRemoved: '{{name}} hat das Label {{oldValue}} entfernt.',
            rejectionEmailSent: '{{name}} hat eine Absage-Email gesendet.',
            allActivities: 'Alle Aktivitäten',
            onlyComments: 'Kommentare',
          },
        },
        quality: {
          ideal: 'Ideal',
          possible: 'Möglich',
          reject: 'Ablehnen',
        },
      },
    },
    chatbotTab: {
      edit: 'Chatbot bearbeiten',
      header: 'Chatbot Vorschau',
      infoText:
        'Das ist der Chatbot, der Ihren potentiellen Bewerbern angezeigt wird.',
      unpublishedChanges:
        'Sie haben unveröffentlichte Änderungen - öffnen Sie den Editor um diese zu veröffentlichen.',
      generatedAutomatically:
        'Dieser Chatbot wurde automatisch erstellt. Sie können ihn gerne nach Belieben anpassen.',
      live: 'Live',
    },
    creativesTab: {
      editPost: 'Post bearbeiten',
      editStory: 'Story bearbeiten',
    },
    creativeBuilder: {
      saveSceneInJob: 'Arbeitsdatei speichern',
      updateCreativesInJob: 'Creatives aktualisieren',
      errors: {
        saveSceneError: 'Fehler beim Speichern der Arbeitsdatei',
        updateCreativesError: 'Fehler beim Aktualisieren der Creatives',
      },
    },
  },
  organizationDetails: {
    details: 'Details',
    billingSection: 'Rechnungsinformationen',
    recruiter: 'Recruiter',
    jobs: 'Jobs',
    contact: 'Meeting vereinbaren',
    addRecruiter: 'Recruiter hinzufügen',
    contactEmail: 'Kontakt',
    homepage: 'Webseite',
    branch: 'Branche',
    numberOfEmployees: 'Anzahl der Mitarbeiter',
    credit: 'Guthaben',
    street: 'Straße, Hausnummer',
    zipCode: 'PLZ',
    city: 'Stadt',
    country: 'Land',
    vatNo: 'USt-IdNr.',
    billingEmail: 'Rechnungskontakt (E-Mail)',
    name: 'Name der Organisation',
    paymentByInvoice: 'Bezahlung auf Rechnung',
  },
  priceWidget: {
    priceCalculatedFor: 'Budget kalkuliert für:',
    runtime_one: '1 Monat',
    runtime_other: '{{count}} Monate',
    reach: '+{{value, number}}',
    perMonth: ' / Monat',
    terms:
      'Ihre Kampagne kann monatlich gekündigt werden oder verlängert sich automatisch um einen Monat.',
    hires_one: '1 Mitarbeiter',
    hires_other: '{{count}} Mitarbeiter',
  },
  registerSidepanel: {
    heading: 'Schalten Sie jetzt Social-Recruiting-Anzeigen.',
    subTitle: 'Ihre Erfolgsfaktoren',
    passiveJobSeekers: 'Erreichen Sie passive Jobsuchende in sozialen Medien',
    prequalifyCandidates: 'Vorauswahl von Kandidaten mit einem Bewerber-Bot',
    optimization: 'KI-Optimierung basierend auf den besten Bewerbern',
    findTopApplicants: 'Finden Sie Top-Bewerber in 3 Schritten',
    step1: 'Erstellen Sie ein Arbeitgeberkonto',
    step2: 'Definieren Sie das Bewerberprofil',
    step3: 'Veröffentlichen Sie die Social-Recruiting-Kampagne',
  },
  onBeforeUnload: {
    message: 'Die Seite hat ungespeicherte Änderungen. Trotzdem verlassen?',
  },
} as const;
